<p-table
  #dtCommissions
  dataKey="id"
  styleClass="p-datatable-striped"
  [tableStyle]="{ 'min-width': '100%', padding: 0 }"
  [value]="commissions"
  [scrollable]="true"
  scrollHeight="525px"
  [rows]="10">
  <ng-template pTemplate="header">
    <tr>
      <th class="w-3" pSortableColumn="date">
        {{ 'Common.Date' | translate
        }}<p-sortIcon field="createdDate"></p-sortIcon>
      </th>
      <th class="w-3" pSortableColumn="commissionAmount">
        {{ 'Common.Amount' | translate
        }}<p-sortIcon field="commissionAmount"></p-sortIcon>
      </th>
      <th class="w-6">{{ 'Common.Type' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-commission>
    <tr>
      <td>{{ commission.date | date: 'dd MMM yyyy hh:mm a' }}</td>
      <td>{{ commission.commissionAmount | currency }}</td>
      <td>
        <span
          [class]="
            'commission-badge type-' + commission.commissionType | lowercase
          ">
          {{ 'Commissions.Types.' + commission.commissionType | translate }}
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">{{ 'Commissions.NotFound' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
